export var EVENTS = {
  CLICK_SELECT_DATES: 'click-select-dates',
  CLICK_REQUEST_TO_BOOK: 'click-request-to-book',
  REQUEST_INTENTION: 'request-intention',
  CLICK_MORE_LISTINGS: 'click-more-listings',
  CLICK_MORE_PLACES_LIKE_THIS: 'click-more-places-like-this',
  VIEW_OFFER_PAGE: 'view-offer-page',
  ADD_TO_WISHLIST: 'add-to-wishlist',
  SUGGESTED_DATES_SHOWN: 'suggested-dates-shown',
  SELECTED_SUGGESTED_DATES: 'selected-suggested-dates',
  SELECTED_ORIGINAL_DATES: 'selected-original-dates',
  REPORT_LISTING_OPEN: 'report-listing-open',
  REPORT_LISTING_SUBMIT: 'report-listing-submit',
  SHARE_LINK: 'share-link',
  REFERRAL_CLICK: 'referral-click',
  FIXED_CONTRACT_MODAL_OPEN: 'fixed-contract-modal-open',
  FIXED_CONTRACT_OPTION_CLICK: 'fixed-contract-option-click',
  FIXED_CONTRACT_CONFIRM_CLICK: 'fixed-contract-confirm-click',
  FIXED_CONTRACT_CANCEL_CLICK: 'fixed-contract-cancel-click',
  OFFER_PAGE_FAQ_OPENED: 'offer-page-faq-opened',
  UNI_TRUST_CLICKED: 'uni-trust-clicked',
  QUICK_PAGE_NAVIGATION: 'quick-page-navigation',
  GALLERY_OPENED: 'gallery-opened',
  MAP_OPENED: 'map-opened',
  SEE_ALL_AMENITIES: 'see-all-amenities',
  ALL_FEATURES_MODAL_OPENED: 'all-features-modal',
  PHOTOS_CAROUSEL_OPENED: 'photos-carousel-opened',
  QUICK_GALLERY_NAVIGATION: 'quick-gallery-navigation',
  SHARED_OFFER: 'shared-offer',
  HELP_CENTER: 'help-center',
  PRICE_REVIEW: 'price-review',
  REQUEST_TO_BOOK_AMPLITUDE: 'request-to-book',
  FLOOR_PLAN_OPENED: 'floor-plan-opened',
  VIDEO_OPENED: 'video-opened'
};